module.exports = __webpack_public_path__ + "img/Categories_bg_09.47a1e17d.jpg";